import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_ASSIGNMENTS: '/GetAllAssignments',
  GET_ALL_USERS_FOR_ASSIGNMENTS: '/GetUsersForAssigments',
  CREATE_ASSIGNMENT: '/AssigmentCreate',
  UPDATE_ASSIGNMENT: '/AssignmentUpdate',
  COMPLETE_ASSIGNMENT: '/AssignmentScaleUpdate',
  GET_ALL_ASSIGNMENTS_EXCEL: '/GetAllAssignmentsExcel'
};

export const getAllAssignments = async (params = {}) => {
  const { date, assigmentId, id, days } = params;
  
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_ALL_ASSIGNMENTS}`;
  const queryParams = new URLSearchParams();

  if (date) {
    queryParams.append('date', date);
  }

  if (assigmentId) {
    queryParams.append('assigmentId', assigmentId);
  }

  if (days) {
    queryParams.append('days', days);
  }

  // Support both id and assigmentId for flexibility
  if (id && !assigmentId) {
    queryParams.append('assigmentId', id);
  }

  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }

  const response = await fetch(url, {
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch assignment data');
  }

  return response.json();
};

export const getAllUsers = async () => {
  const response = await fetch(`${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_ALL_USERS_FOR_ASSIGNMENTS}`, {
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch user data');
  }

  return response.json();
};

export const createAssignment = async (assignmentData) => {
  const formDataToSend = new FormData();
  formDataToSend.append('NumberPlate', assignmentData.numberPlate);
  formDataToSend.append('AssignmentDate', assignmentData.assignmentDate);
  formDataToSend.append('District', assignmentData.district);
  formDataToSend.append('NeighbourHood', assignmentData.neighbourHood);
  formDataToSend.append('ScaleInformation', '');
  formDataToSend.append('ScaleDatetime', '');
  formDataToSend.append('ScaleEnteredUser', '');
  
  // Append each user ID separately
  assignmentData.users.forEach(userId => {
    formDataToSend.append('UserIds', userId);
  });

  const response = await fetch(`${axiosInstance.defaults.baseURL}${ENDPOINTS.CREATE_ASSIGNMENT}`, {
    method: 'POST',
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formDataToSend
  });

  const data = await response.json();
  
  if (data.status !== 200) {
    throw new Error(data.message || 'Görev oluşturulurken bir hata oluştu.');
  }

  return data;
};

export const updateAssignment = async (id, assignmentData) => {
  const formDataToSend = new FormData();
  formDataToSend.append('NumberPlate', assignmentData.numberPlate);
  formDataToSend.append('AssignmentDate', assignmentData.assignmentDate);
  formDataToSend.append('District', assignmentData.district);
  formDataToSend.append('NeighbourHood', assignmentData.neighbourHood);
  formDataToSend.append('ScaleInformation', '');
  formDataToSend.append('ScaleDatetime', '');
  formDataToSend.append('ScaleEnteredUser', '');
  
  // Append each user ID separately
  assignmentData.users.forEach(userId => {
    formDataToSend.append('UserIds', userId);
  });

  const response = await fetch(`${axiosInstance.defaults.baseURL}${ENDPOINTS.UPDATE_ASSIGNMENT}/${id}`, {
    method: 'PUT',
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formDataToSend
  });

  const data = await response.json();
  
  if (data.status !== 200) {
    throw new Error(data.message || 'Görev düzenlenirken bir hata oluştu.');
  }

  return data;
};

export const completeAssignment = async (id, scale) => {
  const formData = new FormData();
  formData.append('scale', scale);

  const response = await fetch(`${axiosInstance.defaults.baseURL}${ENDPOINTS.COMPLETE_ASSIGNMENT}/${id}`, {
    method: 'PUT',
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formData
  });

  if (!response.ok) {
    throw new Error('Görevlendirme ölçümü güncellenemedi');
  }

  return response.json();
};

export const getAllAssignmentsExcel = async (days, date) => {
  try {
    let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_ALL_ASSIGNMENTS_EXCEL}`;
    const queryParams = new URLSearchParams();
    
    if (days) {
      queryParams.append('days', days);
    } else {
      // If no days parameter, use today's date
      const today = new Date().toISOString().split('T')[0];
      queryParams.append('date', date || today);
    }
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }
    
    const response = await fetch(url, {
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Excel dosyası indirilemedi');
    }
    
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    
    // Get current date for filename
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    
    link.download = `Vasita_Verileri_${dateStr}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    return true;
  } catch (error) {
    console.error('Excel indirme hatası:', error);
    throw error;
  }
};


